// Product name translations
export const productTranslations: {
  [key: string]: { en: string; ja: string }
} = {
  'Hero Image': { en: 'Hero Image', ja: 'ヒーロー画像' },
  'Product 1': { en: 'Product 1', ja: '製品 1' },
  'Product 2': { en: 'Product 2', ja: '製品 2' },
  'Product 3': { en: 'Product 3', ja: '製品 3' },
  'Product 4': { en: 'Product 4', ja: '製品 4' },
  'Product 5': { en: 'Product 5', ja: '製品 5' },
  'Product 6': { en: 'Product 6', ja: '製品 6' },
  'Product 7': { en: 'Product 7', ja: '製品 7' },
  'Product 8': { en: 'Product 8', ja: '製品 8' },
  'Product 9': { en: 'Product 9', ja: '製品 9' },
  'Product 10': { en: 'Product 10', ja: '製品 10' },
  'Product 11': { en: 'Product 11', ja: '製品 11' },
  'Product 12': { en: 'Product 12', ja: '製品 12' },
  'Product 13': { en: 'Product 13', ja: '製品 13' },
  'Product 14': { en: 'Product 14', ja: '製品 14' },
  'Product 15': { en: 'Product 15', ja: '製品 15' },
  'Product 16': { en: 'Product 16', ja: '製品 16' }
}

export const products = [
  // ヒーロー画像用オブジェクト（新規追加）
  {
    id: 'hero-1', // ユニークなID
    name: 'Hero Image',
    href: '#',
    imageSrc: 'https://jpblogtzk.imgix.net/pexels-walid-ahmad-1372014.jpg',
    imageAlt: 'Hero Image with Generative Fill',
    price: '',
    isHero: true,
    params: {
      width: '5000',
      height: '1500'
    }
  },
  // Cameras
  {
    id: 5,
    name: 'Omaha Camera',
    href: '#',
    imageSrc: 'https://sdk-test.imgix.net/omeha-camera.jpg',
    price: '$200',
    color: 'Black',
    params: {}
  },
  {
    id: 6,
    name: 'Fujifilm Camera',
    href: '#',
    imageSrc: 'https://jpblogtzk.imgix.net/pexels-pixabay-247304.jpg',
    price: '$350',
    color: 'Black',
    params: {}
  },
  {
    id: 7,
    name: 'Canon Camera',
    href: '#',
    imageSrc: 'https://sdk-test.imgix.net/canon-camera.jpg',
    price: '$459',
    color: 'Black',
    params: {}
  },
  {
    id: 8,
    name: 'Rolleiflex Camera',
    href: '#',
    imageSrc: 'https://sdk-test.imgix.net/rolleiflex-camera.jpg',
    price: '$212',
    color: 'Black',
    params: {}
  },
  // Hats
  {
    id: 10,
    name: 'Feather Hat',
    href: '#',
    imageSrc: 'https://sdk-test.imgix.net/feather-hat.jpg',
    price: '$90',
    color: 'Black',
    params: {}
  },
  {
    id: 13,
    name: 'Blue Hat',
    href: '#',
    imageSrc: 'https://sdk-test.imgix.net/blue-hat.jpg',
    price: '$79',
    color: 'Black',
    params: {}
  },
  {
    id: 14,
    name: 'Wicker Hat',
    href: '#',
    imageSrc:
      'https://sdk-test.imgix.net/fellipe-ditadi-dEU1q5s7GPY-unsplash.jpg',
    price: '$150',
    color: 'Black',
    params: {}
  },
  {
    id: 'hat-1',
    name: 'Bucket Hat',
    href: '#',
    imageSrc: 'https://sdk-test.imgix.net/bucket-hat.jpg',
    price: '$335',
    color: 'Black',
    params: {}
  },
  // Sneakers
  {
    id: 'sneaker-1',
    name: 'Basic Sneaker',
    href: '#',
    imageSrc: 'https://sdk-test.imgix.net/xavier-teo-SxAXphIPWeg-unsplash.jpg',
    imageAlt: "Side of men's black sneaker on blue background",
    price: '$135',
    color: 'Black',
    params: {}
  },
  {
    id: 'sneaker-2',
    name: 'Pink Sneaker',
    href: '#',
    imageSrc: 'https://sdk-test.imgix.net/red-and-white-sneaker.jpg',
    price: '$135',
    color: 'Red',
    params: {}
  },
  {
    id: 'sneaker-3',
    name: 'Basic Running Shoe',
    href: '#',
    imageSrc: 'https://sdk-test.imgix.net/sneaker-large.jpg',
    price: '$149',
    color: 'Orange',
    params: {}
  },
  {
    id: 'sneaker-4',
    name: 'Red Running Shoe',
    href: '#',
    imageSrc: 'https://sdk-test.imgix.net/tennis-sneaker.jpg',
    price: '$120',
    color: 'Red',
    params: {}
  },
  {
    id: 'purse-1',
    name: 'Brown Purse',
    href: '#',
    imageSrc: 'https://sdk-test.imgix.net/brown-chain-purse.jpg',
    price: '$355',
    color: 'Brown',
    params: {}
  },
  {
    id: 'purse-2',
    name: 'Grey Purse',
    href: '#',
    imageSrc: 'https://sdk-test.imgix.net/grey-pruse.jpg',
    price: '$635',
    color: 'Grey',
    params: {}
  },
  {
    id: 'purse-3',
    name: 'Black Purse',
    href: '#',
    imageSrc: 'https://sdk-test.imgix.net/black-purse.jpg',
    price: '$635',
    color: 'Black',
    params: {}
  },
  {
    id: 'purse-4',
    name: 'Purple Purse',
    href: '#',
    imageSrc: 'https://sdk-test.imgix.net/purple-purse.jpg',
    price: '$335',
    color: 'Purple',
    params: {}
  }
]
